import type { BridgeMessageHandler } from '../message-router.js';

export const handlePreviewEnvironmentControl: BridgeMessageHandler<'preview_environment_control'> = (msg, deps) => {
  let wire: Record<string, unknown>;
  try {
    wire = deps.e2ee
      ? (deps.e2ee.decryptMessage(msg as Record<string, unknown>) as Record<string, unknown>)
      : (msg as unknown as Record<string, unknown>);
  } catch (e) {
    deps.log(`[E2EE] Could not decrypt preview environment command: ${e instanceof Error ? e.message : String(e)}`);
    return;
  }
  const environmentId = typeof wire.environmentId === 'string' ? wire.environmentId : '';
  const action = wire.action === 'start' || wire.action === 'stop' ? wire.action : null;
  if (!environmentId || !action) return;
  deps.previewEnvironmentManager?.handleControl(environmentId, action);
};
